import { TWorkoutItem } from '@treino/data-access';
// This method is used to fix the order of items in a workout. By "actuar legado"
// Dont't change it.
export function fixOrder(itens: TWorkoutItem[]): TWorkoutItem[] {
    const groupedBySet = [];
    const tempSets = {};

    itens.forEach((item) => {
        if (item?.Set === 0) {
            item.Set = null;
            item.SetOrder = null;
        }
        if (item.Set !== null) {
            if (!tempSets[item.Set]) {
                tempSets[item.Set] = [];
            }
            tempSets[item.Set].push(item);
        } else {
            groupedBySet.push([item]);
        }
    });

    Object.values(tempSets).forEach((group) => {
        groupedBySet.push(group);
    });

    const filterNull = groupedBySet?.filter(item => item !== null)

    const orderedByArrayPosition = [];

    filterNull.forEach(item => {
        item.sort((a, b) => a.SetOrder - b.SetOrder);
    });

    const sortedByFirstObjOrder = filterNull.sort((a, b) => a[0]?.Order - b[0]?.Order);

    sortedByFirstObjOrder?.forEach(item => {
        orderedByArrayPosition?.push(...item);
    });

    orderedByArrayPosition?.forEach((item, index) => {
        item.Order = index + 1;
    });

    return orderedByArrayPosition;
}